import React, { useEffect, useState } from 'react'
import Check from '../../images/success.png'
import { Box, Button, Modal, Typography } from '@mui/material'
import { useNavigate } from 'react-router'
const RegistrationSuccessPopup = ({ show = false, setShow, affiliateCode = '' }) => {
  const [producerId, setProducerId] = useState('')
  const navigate = useNavigate()

  useEffect(() => {
    if (!affiliateCode || affiliateCode === '') return
    setProducerId(affiliateCode)
  }, [affiliateCode])

  return (
    <Modal
      open={show}
      onClose={() => setShow(false)}
      sx={{
        marginTop: '12rem',
      }}
    >
      <Box sx={modalStyle.box}>
        <Box component="img" src={Check} sx={modalStyle.logo} />
        <Typography variant="h1" sx={modalStyle.title}>
          Registration Successful!
        </Typography>
        <Typography variant="subtitle2" sx={modalStyle.subtitle}>
          Thank you for registering for the NewBridge Portal
        </Typography>
        <Button
          sx={modalStyle.loginButton}
          onClick={() => navigate(`/login/?productId=511801&affiliateCode=CG${producerId}`)}
        >
          Login
        </Button>
      </Box>
    </Modal>
  )
}

const modalStyle = {
  box: {
    display: 'flex',
    gap: '1rem',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    // pt: { lg: '52px', md: '52px', sm: '39px', xs: '24px' },
    pr: { lg: '52px', md: '52px', sm: '39px', xs: '16px' },
    // pb: { lg: '52px', md: '52px', sm: '39px', xs: '24px' },
    pl: { lg: '52px', md: '52px', sm: '39px', xs: '16px' },
    width: { lg: '502px', md: '502px', sm: '502px', xs: '343px' },
    height: { lg: '438px', md: '438px', sm: '438px', xs: '386px' },
    background: '#FFF',
    borderRadius: '8px',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  logo: {
    width: { lg: '70px', md: '91px', sm: '91px', xs: '40px' },
    borderRadius: '100px',
    border: '2px solid black',
  },
  title: {
    fontSize: { lg: '36px', md: '28px', sm: '28px', xs: '22px' },
  },
  subtitle: {
    fontSize: { lg: '16px', md: '13px', sm: '10px', xs: '8px' },
    fontWeight: 'light',
    color: '#64768C',
    fontFamily: 'Roboto!important',
  },
  loginButton: {
    textTransform: 'none',
    width: { lg: '30%', md: '40%', sm: '50%', xs: '60%' },
    height: '40px',
    backgroundColor: '#3C4FB9',
    color: 'white',
    borderRadius: '100px',
    mt: '10px',
    '&:hover': {
      backgroundColor: '#9BA5DF',
      color: '#36414E',
    },
    '&:disabled': {
      backgroundColor: '#C4CAF1',
      color: 'white',
      textTransform: 'none',
    },
  },
}

export default RegistrationSuccessPopup